module.exports = __webpack_public_path__ + "static/media/0191_Small.51a52a13.jpg";